import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ContactService } from './contact.service';

@Injectable({
  providedIn: 'root'
})
export class ContactResolve {

  constructor(
    private cs: ContactService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.cs.updateContact(route.params.id)
  }

}
